import type { HeaderMenu, HeaderMenuIconVariantEnum } from '@/api/hanly/hanlyAPI.schemas';

export const HEADER_MENU_MAX_COUNT = 2;
export const HEADER_MENU_LABEL_MAX_LENGTH = 4;

export interface HeaderMenuIconValue {
  variant: HeaderMenuIconVariantEnum;
  name: string;
}

export const toHeaderMenuIconValue = (menu: Pick<HeaderMenu, 'icon_variant' | 'icon_name'>) => ({
  variant: menu.icon_variant,
  name: menu.icon_name,
});
